import { render } from "./ServiceMenu.vue?vue&type=template&id=01dc97be&scoped=true"
import script from "./ServiceMenu.vue?vue&type=script&lang=js"
export * from "./ServiceMenu.vue?vue&type=script&lang=js"

import "./ServiceMenu.vue?vue&type=style&index=0&id=01dc97be&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01dc97be"]])

export default __exports__